module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABLUlEQVQ4T62TvUrEQBSF780QbOy0ExZLX8FKtvI5DJkhQ0KafQ2LBZOdzKTwOWxcsPIJ7EWsxM4mhMyVBBOymx/Bdbph5nznzGEuwoELD9RDB0jT9JiIjqIo+pyDJklygohFGIZf9b0OYIy5JiLFGFv6vv86BlFKnTPGHquqklLKhx1AvdFahwCwGoO0YgC4FUJsWoNBB2OQKfEgQUvtQ8qyxDr2vvMgQZZllwBwEQTBfX2Y53lorV0hNiG72MYYDxFfOOfPOwmUUmeI+OQ4zloIcVcfZll2wxgDznkD1VrHABBba6+klO9jJS6IaNuH9J7ViF3XXXqe9zZX4gDSOu+L50pcAMAWEddEVJcwcJ5M0IvcQACAxpx/BfyUdloUBcZx/DH1vf9vmP46ld+UV4sR8VyhnAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./common/assets/img/order/down.png
// module id = 9bKH
// module chunks = 1